import type {
  GetApiV1ThreeLetterCodePartnerAdminsUsersUserId200,
  GetApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfile200,
} from '@fukuri-admins/apis/client/gen/model';
import { formatDate } from '@fukuri-admins/utils/common/date/formatDate';
import { getUserEditLink } from '~/utils/getLinks';
import { UserDetailProfilePresentation } from '../presentations';
import { convertCustomFieldsToDisplayItems } from './convertCustomFieldsToDisplayItems';

export { convertCustomFieldsToDisplayItems };

type PresentationProps = React.ComponentProps<typeof UserDetailProfilePresentation>;

type Args = {
  /** 利用者詳細 API のレスポンスデータ */
  data: GetApiV1ThreeLetterCodePartnerAdminsUsersUserId200;
  /** 利用者ID */
  userId: number;
  /** プロフィール API のレスポンスデータ */
  profileData: GetApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfile200;
};

type IConvertToPresentationProps = (
  args: Args
) => Omit<PresentationProps, 'isActivationCodeEnabled'>;

/**
 * API レスポンスを UserDetailProfilePresentation の props に変換する
 * （isActivationCodeEnabled は Container 側で判定して個別に渡す）
 */
export const convertToPresentationProps: IConvertToPresentationProps = ({
  data,
  userId,
  profileData,
}) => {
  const { user } = data;
  return {
    fullName: user.full_name,
    email: user.email ?? '-',
    clientName: user.client.name,
    billableFromLabel: user.billable_from
      ? formatDate({
          date: new Date(`${user.billable_from}T00:00:00`),
          formatType: 'yyyy/M/d',
        })
      : '-',
    createdAtLabel: formatDate({
      date: new Date(user.created_at * 1000),
      formatType: 'yyyy/MM/dd H:mm',
    }),
    updatedAtLabel: formatDate({
      date: new Date(user.updated_at * 1000),
      formatType: 'yyyy/MM/dd H:mm',
    }),
    editLink: getUserEditLink(String(userId)),
    activationCode: user.activation_code ?? '-',
    phoneNumber: user.phone_number ?? '-',
    customFields: convertCustomFieldsToDisplayItems(
      profileData.user_profile.custom_field_values ?? []
    ),
  };
};
